import React, { Component } from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
// import RouterWatcher from './router-watcher';
import NoPage from './views/404'
import ErrorPage from './views/error'
import asyncComponent from './asyncComponent'
import store from './store';
import requireAuth from './requireAuth'
import ScrollTopView from './scrollTopView'
import MaintenancePage from './views/maintenance';

const AsyncDashboard = asyncComponent(() => import('./views/dashboard'))
const AsyncLogin = asyncComponent(() => import('./views/main/login'));
const AsyncDeleteAccount = asyncComponent(() => import('./views/main/delete-account'));
const AsyncRegister = asyncComponent(() => import('./views/main/registration'));
const AsyncResetProfile = asyncComponent(() => import('./views/main/reset-profile'));
const AsyncPasswordReset = asyncComponent(() => import('./views/main/password-reset'));
const AsyncIntro = asyncComponent(() => import('./views/intro'));

class App extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      error: '',
      hasError: false,
    };
  }

  // componentDidMount() {
  //   if(!window.localStorage.getItem('lastUpdateCheck')) {
  //     const newUpdateCheck = new Date().toLocaleString();

  //     window.localStorage.setItem('lastUpdateCheck', newUpdateCheck);
  //   } else {
  //     const lastUpdateCheckDate = new Date(window.localStorage.getItem('lastUpdateCheck'))
  //     const today = new Date()
  //     const dateDifference = Math.floor((today - lastUpdateCheckDate) / (1000*60*60*24))

  //     if(dateDifference >= 1) {
  //       window.localStorage.setItem('lastUpdateCheck', today.toLocaleString());
  //       window.location.reload();
  //     }
  //   }
  // }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  render() {
    const maintenance = false

    const { hasError } = this.state
    return (
      <Provider store={store}>
        <Router>
          <>
            <ScrollTopView>
            {maintenance ? 
              <MaintenancePage />
            :
              (hasError) ? 
                <ErrorPage error={this.state.error} />
              :
              <Switch>
                <Route exact path="/" component={AsyncLogin} />
                <Route path="/login" component={AsyncLogin} />
                <Route path="/delete-account" component={AsyncDeleteAccount} />
                <Route path="/register" component={AsyncRegister} />
                <Route path="/reset" component={AsyncPasswordReset} />
                <Route path="/welcome" component={requireAuth(AsyncIntro)} />
                <Route path="/dashboard" component={requireAuth(AsyncDashboard)} />
                <Route path="/version" component={() => <div>Build Version: 3/31/22</div>} />
                <Route path="/reset-profile" component={requireAuth(AsyncResetProfile)} />
                <Route component={NoPage} />
              </Switch>
              
            }
              
            </ScrollTopView>
          </>
        </Router>
      </Provider>
    );
  }
}

export default App;
